// ONE reader for coded GraphQL errors (inventory hardening D28, 2026-09-18).
//
// The server's ErrorHandler puts a stable code under extensions.code and any
// payload (ids, names, line numbers) beside it in extensions. Branch on the
// code — never on the message text — so copy changes can't break flows.
//
//   const code = gqlErrorCode(err);
//   if (code === "ITEM_INACTIVE") { const { itemId } = gqlErrorExtensions(err); ... }

export function gqlErrorCode(err) {
  const errs = err?.graphQLErrors;
  if (!Array.isArray(errs)) return null;
  for (const ge of errs) {
    const code = ge?.extensions?.code;
    if (typeof code === "string" && code) return code;
  }
  return null;
}

export function gqlErrorExtensions(err) {
  const errs = err?.graphQLErrors;
  if (!Array.isArray(errs)) return null;
  for (const ge of errs) {
    if (ge?.extensions) return { ...ge.extensions };
  }
  return null;
}

// The server's trusted, coded message (formatError passes coded messages
// through verbatim; uncoded ones are masked), else the network error text.
export function gqlErrorMessage(err, fallback = "Something went wrong") {
  const errs = err?.graphQLErrors;
  if (Array.isArray(errs) && errs.length && errs[0]?.message) return errs[0].message;
  if (err?.networkError?.message) return err.networkError.message;
  return err?.message || fallback;
}
